import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Select from 'react-select';

import StatusSelectDropdown from '../../DropdownMenu/InsuranceEdit';
import InsuraceListUpload from './InsuranceListUpload';
import InsuranceListPreview from './InsuranceListPreview';
import InsuranceEdit from './InsuranceEdit';
import InsuranceDuplicate from './InsuranceDuplicate';
import utils from '../../../lib/utils';
import { TextareaField } from '../../common';

const collectInsuranceOptions = [
  {
    value: 'DO_NOT_COLLECT',
    label: 'Do not collect insurance information',
  },
  {
    value: 'ONLY_NEW_PATIENTS',
    label: 'New patients only',
  },
  {
    value: 'UNINSURED_PATIENTS',
    label: 'All patients that do not have one',
  },
];
export default function Insurances(
  {
    preferences,
    values,
    errors,
    onChange,
    setRef,
    paymentTypes,
    insurance,
    recipients,
    getHandler,
    auth,
    insuranceSchema,
  },
) {
  const { accepted_insurances, un_accepted_insurances } = preferences;
  const { properties } = insuranceSchema;
  const [addInsurancename, addInsuranceNameChange] = useState('');
  const [addPopup, addPopupChange] = useState(false);
  const [deletePopup, deletePopupChange] = useState(false);
  const [addInsurancenameNonAcceptance, addInsuranceNameNonAcceptanceChange] = useState('');
  const [selectedAction, selectAction] = useState('');
  const [uploadListModalOpen, modalVisibility] = useState(false);
  const [previewListModalOpen, previewVisibility] = useState(false);
  const [editInsuraceModalOpen, editInsuraceVisibility] = useState(false);
  const [duplicateInsuraceModalOpen, duplicateInsuraceVisibility] = useState(false);
  const [insuranceName, editInsuraceName] = useState({});
  console.log('insurance', insuranceSchema, preferences);
  const handleInputChange = (e) => {
    const insuranceNameRegex = /^[a-zA-Z0-9\s\-\(\)]*$/;
    if (e.target.value === '' || (insuranceNameRegex.test(e.target.value) && e.target.value.trim() !== '')) {
      if (e.target.name === 'acceptedList') {
        addInsuranceNameChange(e.target.value); // Update state when input changes
      } else {
        addInsuranceNameNonAcceptanceChange(e.target.value); // Update state when input changes
      }
    }
  };

  const onAcceptListAdd = (insurance_name) => {
    console.log('insurance_name', accepted_insurances, insurance_name);
    const lowerCaseArray = accepted_insurances.map((item) => item.toLowerCase());
    const unAcceptedLowerCaseArray = un_accepted_insurances.map((item) => item.toLowerCase());
    const lowerCaseNewItem = insurance_name.toLowerCase();
    if (!lowerCaseArray.includes(lowerCaseNewItem) && !unAcceptedLowerCaseArray.includes(lowerCaseNewItem)) {
      let accepted_list = [...accepted_insurances, insurance_name];
      onChange({
        target: {
          name: 'accepted_insurances',
          value: accepted_list,
        },
      });
    } else {
      duplicateInsuraceVisibility(true);
    }
    addPopupChange(true);
    setTimeout(() => {
      addPopupChange(false);
    }, 2000);
    addInsuranceNameChange('');
  };

  const onNonAcceptListAdd = (insurance_name) => {
    console.log('insurance_name', un_accepted_insurances, insurance_name);
    const lowerCaseArray = un_accepted_insurances.map((item) => item.toLowerCase());
    const acceptedLowerCaseArray = accepted_insurances.map((item) => item.toLowerCase());
    const lowerCaseNewItem = insurance_name.toLowerCase();
    if (!lowerCaseArray.includes(lowerCaseNewItem) && !acceptedLowerCaseArray.includes(lowerCaseNewItem)) {
      let accepted_list = [...un_accepted_insurances, insurance_name];
      onChange({
        target: {
          name: 'un_accepted_insurances',
          value: accepted_list,
        },
      });
    } else {
      duplicateInsuraceVisibility(true);
    }
    addInsuranceNameNonAcceptanceChange('');
  };

  const handleAction = (event, key, type) => {
    const values = type === 'un_accepted_insurances' ? un_accepted_insurances : accepted_insurances;
    const selectedValue = values[key];

    if (event === 'edit') {
      editInsuraceVisibility(true);
      editInsuraceName({ selectedValue, type, index: key });
    } else {
      const updatedList = values.filter((_, index) => index !== key);
      onChange({
        target: {
          name: type,
          value: updatedList,
        },
      });
      deletePopupChange(true);
      setTimeout(() => {
        deletePopupChange(false);
      }, 2000);
    }
  };
  const editSaveHandler = (updatedValue, type, index) => {
    const values = type === 'un_accepted_insurances' ? un_accepted_insurances : accepted_insurances;
    values[index] = updatedValue;
    onChange({
      target: {
        name: type,
        value: values,
      },
    });
    editInsuraceVisibility(false);
  };
  const [activeInsurace, setActiveInsurace] = useState(null);
  const [actionDropdownVisibility, setActionDropdownVisibility] = useState(false);
  const onClickofLink = (event, key, inurance_name) => {
    console.log('Event', event.target.id, key);
    if (event.target.id === inurance_name) {
      if (activeInsurace === event.target.id && actionDropdownVisibility) {
        setActionDropdownVisibility(false);
        // setactiveIconVisibility(false);
        setActiveInsurace(null);
      } else {
        setActionDropdownVisibility(key);
        // setactiveIconVisibility(key);
        setActiveInsurace(event.target.id);
      }
    }
  };
  const [uploadedInsurance, setUploadedInsurance] = useState([]);
  const setUploadedInsuranceList = (list) => {
    console.log('CSV LIST', list);
    setUploadedInsurance(list);
    modalVisibility(false);
    previewVisibility(true);
  };
  const deleteFromPreview = (index) => {
    const updatedPreview = [...uploadedInsurance.slice(0, index), ...uploadedInsurance.slice(index + 1)];
    setUploadedInsurance(updatedPreview);
    console.log('updatedPreview', index, updatedPreview);
  };
  const addFromPreview = () => {
    let accepted_list = [...accepted_insurances, ...uploadedInsurance];
    onChange({
      target: {
        name: 'accepted_insurances',
        value: accepted_list,
      },
    });
    previewVisibility(false);
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const insuranceNameRegex = /^[a-zA-Z0-9\s\-\(\)]*$/;
      if (insuranceNameRegex.test(e.target.value) && e.target.value.trim() !== '') {
        if (e.target.name === 'acceptedList') {
          onAcceptListAdd(addInsurancename);
        } else {
          onNonAcceptListAdd(addInsurancenameNonAcceptance);
        }
      }
    }
  };
  return (
    <div className="bookings insurance">
      {properties?.accepted_insurances && (
        <div className="bookings__row">
          <p className="bookings__row__label custom-label">
            {properties?.accepted_insurances?.description || 'Which insurance do you accept?'}
          </p>
          <div className="import-bar">
            <div className="import-bar_description">
              Want to add more than one insurance at a time?
            </div>
            <div className="import-bar_action" onClick={() => modalVisibility(true)}>
              Import insurance list
            </div>
          </div>
          <div className="bookings__row__enclosure">
            <input
              className="inurance-input"
              name="acceptedList"
              type="text"
              placeholder="Insurance name"
              value={addInsurancename}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            {addInsurancename?.length > 0 && (
              <div className="add-insurance" onClick={() => onAcceptListAdd(addInsurancename)}>
                <span>+</span>
                Add
              </div>
            )}
          </div>
          {addPopup && <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Insurance added
          </div>}
          {deletePopup && <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Insurance deleted
          </div>}
          <div className="bookings__row__insurance-list">
            {accepted_insurances.sort((a, b) => a.localeCompare(b)).map((insurance, index) => (
              <div key={`${index}accepted`} className="insurance-name">
                <div className="insurance-name_name">{insurance}</div>
                <div className="insurance-name_actions">
                  <a
                    href="#"
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      onClickofLink(event, true, insurance);
                    }}
                    className={classnames({ 'active-dropdowmn': actionDropdownVisibility })}
                  >
                    <i id={insurance} className="material-icons">more_vert</i>
                  </a>
                  <StatusSelectDropdown
                    visibility={(actionDropdownVisibility && insurance === activeInsurace)}
                    position="br"
                    onVisibilityChange={(visibility) => {
                      setActionDropdownVisibility(visibility, insurance);
                    }}
                    selectedOption={selectedAction}
                    className="menu__dropdown insurance-container"
                    onChange={(event) => handleAction(event, index, 'accepted_insurances')}
                    dropdownMenu={{ edit: true, delete: true }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {properties?.un_accepted_insurances && (
        <div className="bookings__row">
          <p className="bookings__row__label custom-label">
            {properties?.un_accepted_insurances?.description || 'Which insurance you DO NOT accept?'}
          </p>
          <div className="bookings__row__enclosure">
            <input
              className="inurance-input"
              name="unacceptedList"
              type="text"
              placeholder="Insurance name"
              value={addInsurancenameNonAcceptance}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            {addInsurancenameNonAcceptance?.length > 0 && (
              <div className="add-insurance" onClick={() => onNonAcceptListAdd(addInsurancenameNonAcceptance)}>
                <span>+</span>
                Add
              </div>
            )}
          </div>
          <div className="bookings__row__insurance-list">
            {un_accepted_insurances.sort((a, b) => a.localeCompare(b)).map((insurance, index) => (
              <div key={`${index}unaccepted`} className="insurance-name">
                <div className="insurance-name_name">{insurance}</div>
                <div className="insurance-name_actions">
                  <a
                    href="#"
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      onClickofLink(event, true, insurance);
                    }}
                    className={classnames({ 'active-dropdown': actionDropdownVisibility })}
                  >
                    <i id={insurance} className="material-icons">more_vert</i>
                  </a>
                  <StatusSelectDropdown
                    visibility={actionDropdownVisibility && insurance === activeInsurace}
                    position="br"
                    onVisibilityChange={(visibility) => {
                      setActionDropdownVisibility(visibility, insurance);
                    }}
                    selectedOption={selectedAction}
                    className="menu__dropdown insurance-container"
                    onChange={(event) => handleAction(event, index, 'un_accepted_insurances')}
                    dropdownMenu={{ edit: true, delete: true }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <InsuraceListUpload
        modelopen={uploadListModalOpen}
        un_accepted_insurances={un_accepted_insurances}
        accepted_insurances={accepted_insurances}
        modalVisibility={modalVisibility}
        setUploadedInsuranceList={setUploadedInsuranceList}
      />
      <InsuranceListPreview
        modelopen={previewListModalOpen}
        modalVisibility={previewVisibility}
        closeServiceModal={() => previewVisibility(false)}
        deleteFromPreview={deleteFromPreview}
        list={uploadedInsurance}
        addFromPreview={addFromPreview}
      />
      <InsuranceEdit
        modelopen={editInsuraceModalOpen}
        modalVisibility={editInsuraceVisibility}
        closeServiceModal={() => editInsuraceVisibility(false)}
        insuranceName={insuranceName}
        editSaveHandler={editSaveHandler}
      />
      <InsuranceDuplicate
        modelopen={duplicateInsuraceModalOpen}
        modalVisibility={duplicateInsuraceVisibility}
        closeServiceModal={() => duplicateInsuraceVisibility(false)}
      />
      {properties?.collect_insurance &&
        <div className="bookings__row custom-padding-top">
          <p className="bookings__row__label">
            {properties?.collect_insurance?.description || 'What information would you like TrueLark to collect for insurance?'}
          </p>
          <div
            className="notifications__row__input"
            ref={(c) => {
              setRef(c, 'collect_insurance');
            }}
          >
            <Select
              name="collect_insurance"
              // value={collectInsuranceOptions.filter((option) => utils.arrayEquals(option.value, preferences.collect_insurance))}
              value={collectInsuranceOptions.filter(
                (option) => option.value === preferences.collect_insurance,
              )}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={collectInsuranceOptions}
              onChange={(event) => {
                onChange({
                  target: {
                    name: 'collect_insurance',
                    value: event.value,
                  },
                });
              }}
              className={classnames({ 'has-error': errors.collect_insurance })}
            />
            <span className="message--small message--error">
              {errors.collect_insurance && errors.collect_insurance.message}
            </span>
          </div>
        </div>}
      {properties?.insurance_info &&
        <div className="bookings__row custom-padding-top">
          <p className="bookings__row__label">
            {properties?.insurance_info?.description || 'What information would you like TrueLark to collect for insurance?'}
          </p>
          <div className="chats__row__input chat-textarea">
            <TextareaField
              count
              max={160}
              label=""
              value={preferences.insurance_info || ''}
              name="insurance_info"
              onChange={onChange}
              error={errors.insurance_info}
            />
          </div>
        </div>}
      {properties?.no_insurance_info &&
        <div className="bookings__row">
          <p className="bookings__row__label">
            {properties?.no_insurance_info?.description || 'What information would you like TrueLark to share with patients who did not have insurance?'}
          </p>
          <div className="chats__row__input chat-textarea">
            <TextareaField
              count
              max={160}
              label=""
              value={preferences.no_insurance_info || ''}
              name="no_insurance_info"
              onChange={onChange}
              error={errors.no_insurance_info}
            />
          </div>
        </div>}
    </div>
  );
}

Insurances.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ])),
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  insurances: PropTypes.arrayOf(PropTypes.shape()),
};

Insurances.defaultProps = {
  value: [],
  errors: {},
  insurances: [],
};
